"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressCircle = exports.LoopCircle = exports.BaseCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _Spinner = require("./Spinner.types");
var _classnames = _interopRequireDefault(require("./classnames"));
var _kindColorTokens, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var kindColorTokens = (_kindColorTokens = {}, _defineProperty(_kindColorTokens, _Spinner.Kind.DEFAULT, _js["default"].component.spinner.color["default"]), _defineProperty(_kindColorTokens, _Spinner.Kind.CRITICAL, _js["default"].component.spinner.color.critical), _defineProperty(_kindColorTokens, _Spinner.Kind.INVERSE, _js["default"].component.spinner.color.inverse), _kindColorTokens);
var thickness = 3;
var spinnerSize = 21;
var radius = spinnerSize / 2;
var circumference = radius * 2 * Math.PI;
var axisAlignment = 12; // center align by use half of svg container size (24)

var getColorKind = function getColorKind(kind, element) {
  return kindColorTokens[kind][element];
};
var calculateCircleProgress = function calculateCircleProgress(circumference) {
  return function (percentage) {
    var indicatorCircumference = circumference * percentage / 100;
    var baseCircumference = circumference - indicatorCircumference;
    return baseCircumference;
  };
};
var Circle = function Circle(props) {
  return /*#__PURE__*/_react["default"].createElement("circle", _extends({
    fill: "transparent",
    strokeWidth: thickness,
    r: radius,
    cx: axisAlignment,
    cy: axisAlignment
  }, props));
};
var BaseCircle = exports.BaseCircle = (0, _styledComponents["default"])(Circle).attrs({
  className: _classnames["default"].SPINNER_BASE_CIRCLE
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var $kind = _ref.$kind;
  return "\n    stroke: ".concat(getColorKind($kind, 'base'), ";\n  ");
});
var getIndicatorProgress = calculateCircleProgress(circumference);
var indicatorAnimation = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(-90deg);\n  }\n\n  to {\n    transform: rotate(270deg);\n  }\n"])));
var getIndicatorAnimationRule = function getIndicatorAnimationRule() {
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  animation: ", " 900ms linear infinite;\n"])), indicatorAnimation);
};
var LoopCircle = exports.LoopCircle = (0, _styledComponents["default"])(Circle)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var $kind = _ref2.$kind;
  return "\n    stroke: ".concat(getColorKind($kind, 'indicator'), ";\n    stroke-dasharray: ").concat(circumference, " ").concat(circumference, ";\n    stroke-dashoffset: ").concat(getIndicatorProgress(25), ";\n    transform-origin: 50% 50%;\n  ");
}, getIndicatorAnimationRule());
var ProgressCircle = exports.ProgressCircle = (0, _styledComponents["default"])(Circle).attrs(function (_ref3) {
  var $percentage = _ref3.$percentage;
  return {
    style: {
      strokeDashoffset: getIndicatorProgress($percentage) // avoid generate more than 200 classes
    }
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var $kind = _ref4.$kind;
  return "\n    stroke: ".concat(getColorKind($kind, 'indicator'), ";\n    stroke-dasharray: ").concat(circumference, " ").concat(circumference, ";\n    transform: rotate(-90deg);\n    transform-origin: 50% 50%;\n    transition: 300ms stroke-dashoffset;\n  ");
});